<ion-grid>
  <ion-row class="ion-align-items-center">
    <ion-col><ion-searchbar [(ngModel)]="szuro" placeholder="Keresés ügyszám, megnevezés, ügyfél…"></ion-searchbar></ion-col>
    <ion-col size="auto">
      <ion-select [(ngModel)]="allapotSzuro" (ionChange)="betolt()" interface="popover" placeholder="Összes" style="min-width:140px">
        <ion-select-option value="">Összes állapot</ion-select-option>
        <ion-select-option *ngFor="let o of opciok.allapot" [value]="o.value">{{ o.label }}</ion-select-option>
      </ion-select>
    </ion-col>
    <ion-col size="auto"><ion-button (click)="ujUgy()"><ion-icon slot="start" name="add"></ion-icon>Új ügy</ion-button></ion-col>
  </ion-row>
</ion-grid>

<ion-list lines="full">
  <ion-item *ngIf="szurtUgyek.length === 0"><ion-label color="medium">Nincs megjeleníthető ügy.</ion-label></ion-item>
  <ion-item button *ngFor="let u of szurtUgyek" (click)="megnyit(u.id)">
    <ion-icon slot="start" name="briefcase" color="primary"></ion-icon>
    <ion-label>
      <h2><b>{{ u.ugyazonosito }}</b> — {{ u.leiras }}</h2>
      <p>{{ u.ugyfelek || 'nincs ügyfél' }}<span *ngIf="u.ugytipus_nev"> · {{ u.ugytipus_nev }}</span></p>
    </ion-label>
    <ion-badge slot="end" [color]="szin(u.allapot)">{{ cimke(opciok.allapot, u.allapot) }}</ion-badge>
  </ion-item>
</ion-list>

<ion-modal #ugyModal>
  <ng-template>
    <ion-header><ion-toolbar color="primary">
      <ion-title>Új ügy</ion-title>
      <ion-buttons slot="end"><ion-button (click)="ugyModal.dismiss()">Mégse</ion-button></ion-buttons>
    </ion-toolbar></ion-header>
    <ion-content class="ion-padding" *ngIf="szerk">
      <ion-list>
        <ion-item>
          <ion-select label="Ügytípus" labelPlacement="stacked" [(ngModel)]="szerk.ugytipus_id" interface="popover">
            <ion-select-option [value]="null">Be nem sorolt ügy</ion-select-option>
            <ion-select-option *ngFor="let t of ugytipusValaszthato()" [value]="t.id">{{ t.label }}</ion-select-option>
          </ion-select>
        </ion-item>
        <ion-item><ion-input label="Ügy megnevezése *" labelPlacement="stacked" [(ngModel)]="szerk.leiras"></ion-input></ion-item>
        <ion-item><ion-input label="Ügygazda (felelős)" labelPlacement="stacked" [(ngModel)]="szerk.ugygazda"></ion-input></ion-item>
        <ion-item><ion-input type="date" label="Megbízás dátuma" labelPlacement="stacked" [(ngModel)]="szerk.megbizas_datum"></ion-input></ion-item>
        <ion-item><ion-input type="number" label="Óradíj (Ft)" labelPlacement="stacked" [(ngModel)]="szerk.oradij"></ion-input></ion-item>
      </ion-list>

      <ion-list-header><ion-label>Szereplők</ion-label></ion-list-header>
      <ion-list lines="full">
        <ion-item *ngFor="let s of ujSzereplok; let i = index">
          <ion-label><h3>{{ s.nev }}</h3><p>{{ s.szerep }}<span *ngIf="s.sajat_ugyfel"> · saját ügyfél</span></p></ion-label>
          <ion-button slot="end" fill="clear" color="danger" (click)="szereploTorol(i)"><ion-icon name="trash"></ion-icon></ion-button>
        </ion-item>
      </ion-list>
      <!-- Kereshetős személyválasztó -->
      <ion-searchbar [(ngModel)]="szemelyKereso" placeholder="Személy keresése a törzsből (név, szül. hely, szem. szám)…"></ion-searchbar>
      <ion-list *ngIf="szemelyKereso.trim()" lines="full" style="max-height:220px;overflow:auto">
        <ion-item button *ngFor="let s of szemelyTalalatok" (click)="valasztSzemely(s)">
          <ion-icon slot="start" name="person" color="primary"></ion-icon>
          <ion-label><h3>{{ s.nev }}</h3><p><span *ngIf="s.szuletesi_ido">{{ s.szuletesi_ido }}</span><span *ngIf="s.szuletesi_hely"> · {{ s.szuletesi_hely }}</span></p></ion-label>
        </ion-item>
        <ion-item *ngIf="szemelyTalalatok.length === 0"><ion-label color="medium">Nincs találat.</ion-label></ion-item>
      </ion-list>
      <ion-chip *ngIf="szemelyValasztott" color="primary" outline="true">
        <ion-icon name="person"></ion-icon><ion-label>{{ szemelyValasztott.nev }}</ion-label>
        <ion-icon name="close-circle" (click)="szemelyValasztott=null; szemelyValaszto=''"></ion-icon>
      </ion-chip>

      <ion-item>
        <ion-select label="Szerepkör" labelPlacement="stacked" [(ngModel)]="ujSzerep" interface="popover">
          <ion-select-option *ngFor="let o of opciok.szerep" [value]="o.value">{{ o.label }}</ion-select-option>
        </ion-select>
        <ion-button slot="end" (click)="szereploHozzaad()">Hozzáad</ion-button>
      </ion-item>
      <ion-item *ngIf="ujSzerep === 'Egyéb'">
        <ion-input label="Egyéb szerepkör megnevezése" labelPlacement="stacked" [(ngModel)]="ujSzerepEgyeb" placeholder="pl. Kezes, Örökös, Szakértő…"></ion-input>
      </ion-item>
      <ion-note class="ion-padding-start" color="medium">Új személyt a Személyek fülön tudsz felvenni.</ion-note>

      <ion-button expand="block" class="ion-margin-top" (click)="mentes()">Ügy létrehozása</ion-button>
    </ion-content>
  </ng-template>
</ion-modal>
